import React, { useState } from "react";
import { ReactComponent as Assessment } from "assets/img/icons/user_assessment.svg";
import UserAssessment from "views/UserProfile/UserAssessment/UserAssessment";
import { useUserContext } from "store/contexts/userContext";
export default ({ history, show }) => {
  const { user } = useUserContext();
  const [openModal, setOpenModal] = useState(false);
  var locationName = history.location.pathname.split("/");

  return (
    <>
      {locationName[1] === "profile" &&
        Number(locationName[2]) === user?.id &&
        (show ? (
          <>
            <hr className="dropDownDivider" />
            <li className="dropDownItem" onClick={() => setOpenModal(true)}>
              <Assessment className={show && "assessment"} />
              {show && "Assessment"}
            </li>
          </>
        ) : (
          <p
            className={show ? "assessment" : "assessmentMobile"}
            onClick={() => setOpenModal(true)}
          >
            <Assessment />
            {show && "Assessment"}
          </p>
        ))}
      {openModal && (
        <UserAssessment setOpenModal={setOpenModal} openModal={openModal} />
      )}
    </>
  );
};
